@if (background_image) {
  <div class="relative h-60 profileimageoverlaydark" data-testid="module-header">
    <img
      class="h-60 w-full absolute object-cover rounded-t-lg"
      data-testid="module-header__background"
      [src]="background_image" />
    <div
      class="h-full relative w-full flex items-center !z-10"
      data-testid="module-header__content">
      <div class="p-4 pb-0 flex flex-col text-white" data-testid="module-header__info">
        <!--
        <span class="text-base md:text-3xl" data-testid="module-header__subtitle">{{
          moduleData.subtitle | translate
        }}</span>
        -->
        <span class="text-lg md:text-4xl font-semibold" data-testid="module-header__title">{{
          moduleData.title | translate
        }}</span>
        @if (wg_title) {
          <span
            class="text-sm md:text-lg font-ligth text-blue-500 leading-6"
            data-testid="module-header__wg-title"
            >{{ wg_title }}</span
          >
        }
        <!--
        @if (moduleData.menuItems && moduleData.menuItems.length > 0) {
          <p-breadcrumb
            data-testid="module-header__breadcrumb"
            class="max-w-full"
            styleClass="!bg-transparent"
            [model]="moduleData.menuItems"
            (onItemClick)="navigateItem($event)">
            <ng-template #item let-item>
              <ng-container *ngIf="item.route; else elseBlock">
                <a class="p-breadcrumb-item-link" [routerLink]="item.route">
                  <div class="cursor-pointer p-breadcrumb-item-link">
                    <span [ngClass]="[item.icon ? item.icon : '', 'text-white']"></span>
                    <span class="text-white">{{ item.label }}</span>
                  </div>
                </a>
              </ng-container>
              <ng-template #elseBlock>
                <a [href]="item.url">
                  <span class="text-white cursor-pointer">{{ item.label }}</span>
                </a>
              </ng-template>
            </ng-template>
            <ng-template #separator> / </ng-template>
          </p-breadcrumb>
        }
        -->
      </div>
    </div>
  </div>
} @else {
  <div class="no-bg-header p-2 pb-0" data-testid="module-header">
    <div class="w-full flex flex-col justify-between !z-10" data-testid="module-header__content">
      <div class="p-4 pb-0 flex flex-col" data-testid="module-header__info">
        <div class="md:text-3xl">
          <!--
          <div class="text-lg font-bold text-primary" data-testid="module-header__title">
            {{ moduleData.subtitle | translate }}
          </div>
        -->
          <div data-testid="module-header__subtitle" class="font-semibold text-4xl mb-1">
            {{ moduleData.title | translate }}
          </div>

          @if (wg_title) {
            <span
              class="font-light text-blue-500 leading-6"
              data-testid="module-header__wg-title"
              >{{ wg_title }}</span
            >
          }
        </div>
        <!--
        @if (moduleData.menuItems && moduleData.menuItems.length > 0) {
          <p-breadcrumb
            data-testid="module-header__breadcrumb"
            class="max-w-full opacity-60"
            styleClass="!bg-transparent"
            [model]="moduleData.menuItems"
            (onItemClick)="navigateItem($event)">
            <ng-template #item let-item>
              <ng-container *ngIf="item.route; else elseBlock">
                <a class="p-breadcrumb-item-link" [routerLink]="item.route">
                  <div class="cursor-pointer p-breadcrumb-item-link">
                    <span [ngClass]="[item.icon ? item.icon : '', '']"></span>
                    <span>{{ item.label }}</span>
                  </div>
                </a>
              </ng-container>
              <ng-template #elseBlock>
                <a [href]="item.url">
                  <span class="cursor-pointer">{{ item.label }}</span>
                </a>
              </ng-template>
            </ng-template>
            <ng-template #separator> / </ng-template>
          </p-breadcrumb>
        }
        -->
      </div>
    </div>
  </div>
}
